import colors from "../../base/colors";
import typography from "../../base/typography";
import pxToRem from "../../functions/pxToRem";

const { primary , secondary} = colors;
const { fontWeightLighter, fontWeightBold } = typography;

const cardHeader = {
  styleOverrides: {
    root: {
      marginTop: 0,
      marginBottom: 0,
      padding: `${pxToRem(8)} ${pxToRem(24)} ${pxToRem(24)}`,
      fontVariant: "all-small-caps",
    },
    title: {
      color: primary.light,
      fontWeight: fontWeightBold,
    },
    subheader: {
      color: secondary.light,
      fontWeight: fontWeightLighter,
      fontSize: "16px",
    },
  },
};

export default cardHeader;
